$(document).ready(function functionName() {
  var duration = 4000
  if ($('.numbers-component').length) {
    var waypoint = new Waypoint({
      element: $('.numbers-component'),
      handler: function(direction) {
        numbers()
        this.destroy()
      },
      offset: 600,
      triggerOnce: true
    })
  }

  var numbers = (function() {
    var $componentEl = $('.numbers-component');

    $componentEl.each(function() {
      var $numbers = $(this).find('.number')
      $numbers.each(animateIn)
    })

    function chunk(str, n, char) {
      var ret = []
      var i

      for (i = str.length; i >= 0; i -= n) {
        ret.unshift(str.substr(i, n))
      }
      if (i < 0) {
        ret.unshift(str.substr(0, i + 3))
      }

      return ret
    }

    function animateIn(index, element) {
      var additional = ""
      var pre = ""
      if (!$(element).attr('data-target')) return false
      if ($(element).attr('data-prefix')) pre = $(element).attr('data-prefix')
      if ($(element).attr('data-suffix')) additional = $(element).attr('data-suffix')
      var defaultVal = parseFloat($(element).attr('data-target'))
      //var defaultVal = parseFloat($(element).html().split(' ').join(''))
      if (isNaN(defaultVal)) {
        defaultVal = 0;
      }
      var defaultValString = chunk((defaultVal).toString(), 3).join(' ')
      $({
        number: 0
      }).stop(true).animate({
        number: defaultVal,
        additional: additional,
      }, {
        duration: duration,
        easing: "easeOutExpo",
        step: function() {
          var num = Math.round(this.number);
          var numberString = chunk((num).toString(), 3).join(' ')
          $(element).html(pre + numberString + additional);
        }
      }).promise().done(function() {
        var numberString = chunk((defaultVal).toString(), 3).join(' ')
        $(element).text(pre + numberString + additional);
      });
    }
  })
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/numbers.js